// Lista modeli producenta (i serii) z katalogu, do wyboru „producent, seria, model” w preferencjach doboru
// (runda 5, 2026-10-12). Korzysta z istniejących list modeli (`GET /api/{panel,inverter,magazine}_models/`),
// które filtrują po serii tą samą funkcją co silnik doboru (`series_in`, backend_api/series.py).
// `szukaj_modeli` tu nie wystarcza: zwraca najwyżej 8 wyników i nie zna serii.
import { apiFetch } from './apiFetch'

const apiUrl = process.env.REACT_APP_API_URL || '/api/'

// Kategoria preferencji -> lista modeli i pole mocy (moduł w W, falownik w kW, magazyn w kWh).
const LISTA = {
  panels: { sciezka: 'panel_models/', moc: 'power' },
  inverter: { sciezka: 'inverter_models/', moc: 'power' },
  battery: { sciezka: 'magazine_models/', moc: 'capacity' },
}

// Więcej niż ma największa seria w katalogu; bez serii lista producenta bywa dłuższa, ale do wyboru
// z rozwijanej listy i tak trzeba ją zawęzić serią albo wyszukiwarką.
const LIMIT = 100

/**
 * Modele z ceną (te same, z których liczymy serie w `sprawdz_oferte/opcje`), posortowane po mocy.
 * Zwraca [{ model_id, nazwa, producent, moc, ofert, img_url, slug }] albo [] przy błędzie.
 */
export const modeleProducenta = async (kategoria, producent, seria) => {
  const cfg = LISTA[kategoria]
  if (!cfg || !producent) return []
  const par = new URLSearchParams({ manufacturers: producent, public_price_only: 'true', limit: String(LIMIT) })
  if (seria) par.set('series_in', seria)
  try {
    const res = await apiFetch(`${apiUrl}${cfg.sciezka}?${par}`)
    if (!res.ok) return []
    const d = await res.json()
    return (d.items || [])
      .map((m) => ({
        model_id: m.id, nazwa: m.name, producent: m.manufacturer, moc: m[cfg.moc] ?? null,
        ofert: m.offer_count ?? null, img_url: m.img_url || null, slug: m.slug || null,
      }))
      .sort((a, b) => (Number(a.moc) || 0) - (Number(b.moc) || 0) || String(a.nazwa).localeCompare(String(b.nazwa), 'pl'))
  } catch {
    return []
  }
}
